var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientSalaryRangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22596 4.90698H4.20311C4.05967 4.90698 3.94336 5.02326 3.94336 5.16673V6.03837C3.94336 6.18181 4.05964 6.29812 4.20311 6.29812H7.22596C7.3694 6.29812 7.4857 6.18184 7.4857 6.03837V5.16673C7.4857 5.02326 7.3694 4.90698 7.22596 4.90698Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78025 6.29812H11.8031C11.9466 6.29812 12.0629 6.18184 12.0629 6.03837V5.16673C12.0629 5.02329 11.9466 4.90698 11.8031 4.90698H8.78025C8.63682 4.90698 8.52051 5.02326 8.52051 5.16673V6.03837C8.52054 6.18181 8.63682 6.29812 8.78025 6.29812Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52051 2.74083V3.61247C8.52051 3.7559 8.63679 3.87221 8.78025 3.87221H11.8031C11.9466 3.87221 12.0629 3.75593 12.0629 3.61247V2.74083C12.0629 2.59739 11.9466 2.48108 11.8031 2.48108H8.78022C8.63679 2.48108 8.52051 2.59739 8.52051 2.74083Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4857 2.74083C7.4857 2.59739 7.36942 2.48108 7.22596 2.48108H4.20311C4.05967 2.48108 3.94336 2.59736 3.94336 2.74083V3.61247C3.94336 3.7559 4.05964 3.87221 4.20311 3.87221H7.22596C7.3694 3.87221 7.4857 3.75593 7.4857 3.61247V2.74083Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5529 8.66277H11.6598C11.7883 8.50369 11.9253 8.33353 12.0627 8.16273V7.53135C12.0627 7.38791 11.9465 7.27161 11.803 7.27161H10.8154C11.2425 7.58702 11.5201 8.08292 11.5529 8.66277Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9851 8.42242C14.8662 7.66214 13.7923 7.43717 13.3752 8.08425C13.3752 8.08425 11.7914 10.0611 11.7018 10.149C11.3408 10.5034 10.8631 10.7004 10.3564 10.7036L6.7887 10.7228H6.7863C6.55327 10.7228 6.34477 10.5683 6.28667 10.3426C6.19822 9.99909 6.45442 9.68971 6.78398 9.68822L9.70143 9.66894C10.8847 9.64337 10.869 7.90073 9.69791 7.88157L8.27698 7.87618C8.19999 7.87603 8.12434 7.85799 8.05456 7.82547C6.01667 6.87546 3.54724 7.16717 1.90837 8.55203C1.815 8.63093 1.69673 8.6742 1.57447 8.6742H0L0.000820313 11.0025L1.89454 11.0312C2.00361 11.0323 2.11175 11.0513 2.21464 11.0874C2.82261 11.3012 4.99749 12.0752 5.87414 12.3874C6.11921 12.4746 6.37729 12.5192 6.63741 12.5192H11.1479C11.6425 12.5192 12.1122 12.3017 12.4321 11.9244L14.8458 9.07826C14.9783 8.88513 15.0277 8.65299 14.9851 8.42242Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSalaryRangeIcon);
export default __webpack_public_path__ + "static/media/client-salary-range-icon.2356d44d.svg";
export { ForwardRef as ReactComponent };